export class IProcedureCodes {
    cptMasterId: string;
    facilityId: number;
    isActive: boolean;
    masterId: number;
    cptCode: string;
    procedureName: string;
    createdBy: string;
    aliasName: string;
    categoryId: number;
    activeStatus: boolean;
    categoryName: string;
    diagnosisId: number;
    diagnosis: string;
    region: string;
    cptId: number;
    regionid: number;
    background: string;
}
export class IprocedureCode {
    cptMasterId: string;
    categoryId: number;
    categoryName: string;
    regionid: number;
    customerdescription: string;
    cliniciandescription: string;
    cptCode: string;
    icdCode: string;
    cptId: number;
    createdBy: string;
    createdOn: Date;
    modifiedBy: string;
    aliasName: string;
    modifiedOn: Date;
    procedureName: string;
    diagnosis: string;
    categoryCodes: Icategorycode[];
    icdCodes: IDiagnosis[];
    selected: boolean;
    price?:number;
}
export class Icategorycode {
    category: string;
    CustomerFriendlyDescription: string;
    Actions: string;
    categoryid: number;
}

export class IDiagnosis {
    IcdCode: string;
    IcdDescription: string;
}

export class ISnomed {

    ConceptCode: string;
    ConceptName: string;
    PreferredConceptName: string;
    PreferredAlternateCode: string;
    CodeSystemOID: string;
    CodeSystemName: string;
    CodeSystemCode: string;
    CodeSystemVersion: string;
    HL7Table0396Code: string;
    ConceptCodeNameCode: string;

}

export class ISnomedDX {

    ConceptCode: string;
    ConceptName: string;
    PreferredConceptName: string;
    PreferredAlternateCode: string;
    CodeSystemOID: string;
    CodeSystemName: string;
    CodeSystemCode: string;
    CodeSystemVersion: string;
    HL7Table0396Code: string;
    ConceptCodeNameCode: string;
    categoryId: string;
}
